import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useAlert } from 'src/hooks';

const useStyles = makeStyles()(theme => ({
  alertBtn: { margin: '0px' },
  alertCancelBtn: { margin: '0px', color: theme.palette.text.primary },
  title: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    color: theme.palette.text.primary,
  },
  content: { padding: theme.spacing(2) },
  warningTitle: {
    background: theme.palette.warning.light,
  },
  actionsRoot: {
    margin: `${theme.spacing(0.5)} 0px ${theme.spacing(0.5)} 0px`,
    padding: `0px`,
  },
  mainDialog: {
    padding: `${theme.spacing(0.5)} ${theme.spacing(0.5)} 0px ${theme.spacing(0.5)}`,
  },
}));

const Alert = () => {
  const { classes } = useStyles();
  const { showAlert, alertConfig } = useAlert();
  const { t } = useTranslation();

  const closeAlert = useCallback(() => {
    showAlert(null);
  }, [showAlert]);

  return (
    alertConfig && (
      <Dialog
        open
        onClose={alertConfig.allowBackdropClose !== false ? closeAlert : undefined}
        disableEscapeKeyDown={alertConfig.allowBackdropClose === false}
        classes={{ paper: classes.mainDialog }}
        scroll="paper"
      >
        <DialogTitle
          classes={{ root: classes.title }}
          className={`${alertConfig.type ? ` ${classes[`${alertConfig.type}Title`]}` : ''}`}
        >
          {alertConfig.title || 'Informations'}
        </DialogTitle>
        <DialogContent>
          {alertConfig.customContent ? (
            alertConfig.customContent
          ) : (
            <DialogContentText
              className={`${classes.content}`}
              dangerouslySetInnerHTML={{ __html: alertConfig.msg }}
            />
          )}
        </DialogContent>
        <DialogActions classes={{ root: classes.actionsRoot }}>
          {alertConfig.onDismiss && (
            <Button
              onClick={e => {
                e.preventDefault();
                alertConfig.onDismiss();
              }}
              classes={{
                root: classes.alertCancelBtn,
              }}
              variant="text"
            >
              {t('smartmessaging.alerts.dismiss')}
            </Button>
          )}
          {alertConfig.onConfirm && (
            <Button
              classes={{
                root: classes.alertBtn,
              }}
              onClick={e => {
                e.preventDefault();
                alertConfig.onConfirm();
              }}
              variant="text"
              color="primary"
            >
              {t('smartmessaging.alerts.confirm')}
            </Button>
          )}
          {!alertConfig.onDismiss && !alertConfig.onConfirm && (
            <Button
              onClick={e => {
                e.preventDefault();
                closeAlert();
              }}
              variant="text"
              color="primary"
            >
              {t('smartmessaging.alerts.done')}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    )
  );
};

export default Alert;
